import { render, staticRenderFns } from "./lkSignApprove.vue?vue&type=template&id=4cf92dd5&scoped=true"
import script from "./lkSignApprove.vue?vue&type=script&lang=js"
export * from "./lkSignApprove.vue?vue&type=script&lang=js"
import style0 from "./lkSignApprove.vue?vue&type=style&index=0&id=4cf92dd5&prod&scoped=true&lang=css"
import style1 from "./lkSignApprove.vue?vue&type=style&index=1&id=4cf92dd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf92dd5",
  null
  
)

export default component.exports